import { useEffect, useState, useRef } from "react";

export default function useTypewriter(text, speed = 18) {
  const [output, setOutput] = useState("");
  const [done, setDone] = useState(false);
  const idxRef = useRef(0);

  useEffect(() => {
    setOutput("");
    setDone(false);
    idxRef.current = 0;
    if (!text) return;

    const id = setInterval(() => {
      idxRef.current += 1;
      setOutput(text.slice(0, idxRef.current));
      if (idxRef.current >= text.length) {
        clearInterval(id);
        setDone(true);
      }
    }, speed);

    return () => clearInterval(id);
  }, [text, speed]);

  return { output, done };
}
